<p-dialog
    id="confirm-delete-order-modal"
    class="custom-modal modal-warning"
    pAutoFocus
    [autofocus]="true"
    [modal]="true"
    [draggable]="false"
    [closable]="false"
    [visible]="selectedOrderId !== null"
    [resizable]="false"
    (visibleChange)="closeModal()"
    (onHide)="closeModal()">
    <ng-template pTemplate="header">
        <h3 class="modal-title">
            <i class="fa-regular fa-triangle-exclamation"></i>
            {{ 'order.list.table.confirmDeleteModal.title' | translate }}
        </h3>
        <p-button
            [style.visibility]="deletionInProgress ? 'hidden' : 'visible'"
            [autofocus]="true"
            pAutoFocus
            id="close-icon"
            icon="fa-regular fa-xmark"
            [disabled]="deletionInProgress"
            [rounded]="true"
            [text]="true"
            (click)="closeModal()">
        </p-button>
    </ng-template>

    <div class="container">
        <p [innerHTML]="'order.list.table.confirmDeleteModal.content' | translate"></p>

        <p-divider></p-divider>
    </div>

    <div class="footer">
        <p-button
            id="cancel-btn"
            [outlined]="true"
            severity="secondary"
            [disabled]="deletionInProgress"
            (click)="closeModal()">
            {{ 'cancel' | translate }}
        </p-button>
        <p-button
            id="confirm-btn"
            [loading]="deletionInProgress"
            [disabled]="deletionInProgress"
            (click)="confirmDeletion()">
            {{ 'order.list.table.confirmDeleteModal.confirmButton' | translate }}
        </p-button>
    </div>
</p-dialog>
